module.exports = __webpack_public_path__ + "assets/menu-search-f9611c.svg";